import React from 'react'
import BoxCard from '../../BoxPage/BoxCard'
import SlotCard from '../../Slot/SlotCard'
import UserCard from '../../User/UserCard'
import { Image } from 'antd'

export default function CollapseContent ({ box, slot, date, isNow, siderDisabled }) {
  return (
    <div style={{ gap: '1em', display: 'flex', flexDirection: 'column' }}>
      <div
        className='slotPageContainer'
        style={{
          gap: '1em',
          flex: 1,
          display: 'flex',
          flexDirection: 'horizontal',
          position: 'relative'
        }}>
        <div className="cards" style={{ gap: '1em', display: 'flex', flexDirection: 'column' }}>
          {box && <BoxCard box={box} disabled={siderDisabled} />}
          {date && <SlotCard date={date} isNow={isNow} box={box} disabled={siderDisabled} />}
          {slot && <UserCard slot={slot} />}
        </div>
      </div>
      {
        box && box.waiting_time_url &&
        <Image
          width={'30em'}
          src={box.waiting_time_url.url}
        />
      }
    </div>
  )
}
